@let assistantSelectionDisabled =
  assistantGroup.messages.plugins.currentListPlugin.feature.selectors.ids.asSignal()
    .length > 0;

<div class="stm-chat">
  <div class="stm-chat__sidebar">
    <atn-conversation-selector />
  </div>
  <div class="stm-chat__main">
    <div class="stm-chat__message-list">
      <atn-chat-message-list />
    </div>
    <div class="stm-chat__input">
      <atn-assistant-message-input
        class="atn-assistant-conversational__message-input"
        [assistantSelectionDisabled]="assistantSelectionDisabled"
        [(selectedAgentId)]="assistantGroup.selectedAgentIdSg"
        (submit)="submitMessage($event)"
        [allowFileAttachments]="true"
        [assistants]="accessibleAssistants.asSignal()"
      />
    </div>
  </div>
</div>
